export const CUSTOMER_PRODUCT_RATING_LIST_REQUEST =
  'CUSTOMER_PRODUCT_RATING_LIST_REQUEST';
export const CUSTOMER_PRODUCT_RATING_LIST_SUCCESS =
  'CUSTOMER_PRODUCT_RATING_LIST_SUCCESS';
export const CUSTOMER_PRODUCT_RATING_LIST_FAILURE =
  'CUSTOMER_PRODUCT_RATING_LIST_FAILURE';
export const CUSTOMER_PRODUCT_RATING_LIKE_REQUEST =
  'CUSTOMER_PRODUCT_RATING_LIKE_REQUEST';
export const CUSTOMER_PRODUCT_RATING_LIKE_SUCCESS =
  'CUSTOMER_PRODUCT_RATING_LIKE_SUCCESS';
export const CUSTOMER_PRODUCT_RATING_LIKE_FAILURE =
  'CUSTOMER_PRODUCT_RATING_LIKE_FAILURE';
export const CUSTOMER_PRODUCT_RATING_DISLIKE_REQUEST =
  'CUSTOMER_PRODUCT_RATING_DISLIKE_REQUEST';
export const CUSTOMER_PRODUCT_RATING_DISLIKE_SUCCESS =
  'CUSTOMER_PRODUCT_RATING_DISLIKE_SUCCESS';
export const CUSTOMER_PRODUCT_RATING_DISLIKE_FAILURE =
  'CUSTOMER_PRODUCT_RATING_DISLIKE_FAILURE';
export const CUSTOMER_PRODUCT_RATING_DELETE_REQUEST =
  'CUSTOMER_PRODUCT_RATING_DELETE_REQUEST';
export const CUSTOMER_PRODUCT_RATING_DELETE_SUCCESS =
  'CUSTOMER_PRODUCT_RATING_DELETE_SUCCESS';
export const CUSTOMER_PRODUCT_RATING_DELETE_FAILURE =
  'CUSTOMER_PRODUCT_RATING_DELETE_FAILURE';
